var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"invoice-status",class:_vm.modifier},[_c('span',{staticClass:"invoice-status__label"},[_vm._v(_vm._s(_vm.status))]),(_vm.showDays)?_c('span',{staticClass:"invoice-status__days"},[_vm._v(" ("+_vm._s(_vm.$tc('invoices.status.days-till-due-date', _vm.invoice.DaysTillDueDate))+") ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }